import workspaceQuery from '../../../graphql/queries/sales/PickingInstructionWorkspaceQuery.graphql';
import listQuery from '../../../graphql/queries/sales/PickingInstructionListQuery.graphql';
import instanceQuery from '../../../graphql/queries/sales/PickingInstructionQuery.graphql';
import fragment from '../../../graphql/fragments/sales/PickingInstructionFragment.graphql';

import generateMutation from '../../../graphql/mutations/sales/PickingInstructionGenerateMutation.graphql';
import generateSingleMutation from '../../../graphql/mutations/sales/PickingInstructionGenerateSingleMutation.graphql';
import generateRangeMutation from '../../../graphql/mutations/sales/PickingInstructionGenerateRangeMutation.graphql';
import reprintMutation from '../../../graphql/mutations/sales/PickingInstructionReprintMutation.graphql';

import * as printFunctions from '../../../actions/sales/PickingInstructionAction';
import { customerDocument } from '../../../utils/mailMergeFields';
import { EntityType } from '../../../@types/entityTypes';
import { ReportType } from '../../schema/p4types';

const PickingInstruction: EntityType = {
  type: 'PickingInstruction',
  title: 'Picking Instructions',
  formUrl: '/Sales/PickingInstruction/Form/',
  formTitle: 'Print Picking Instructions',
  workspaceUrl: '/Sales/PickingInstruction/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  generate: generateMutation,
  generateRange: generateRangeMutation,
  generateSingle: generateSingleMutation,
  reprintRange: reprintMutation,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'documentNumber',
  },
  fragment,
  printFunctions: printFunctions,
  screenReference: 'SALES_DOCUMENTS_PICKING_INSTRUCTIONS',
  configuration: {
    title: 'Picking Instructions',
    field: 'pickingInstructionDefault',
    reportType: ReportType.SalesPickingList,
  },
  operations: 0,
  mergeFields: [
    ...customerDocument,
    {
      key: 'salesOrderNumber',
      text: 'Sales Order Number',
    },
  ],
};

export default PickingInstruction;
